import React from "react";
import { Text, Card } from "@mantine/core";
import { ClearscreenReport } from ".";
import EngagementReport from "@legacy/Reports/EngagementReport";
import Report360 from "@legacy/360";
import CompetencyAssessment from "@legacy/Reports/CompetencyAssessment";

import "@legacy/Reports/index.scss";

export default function ReportDisplay({ meta }) {
  if (!meta || !meta.type) return <Text>No report type provided</Text>;

  if (meta.type === "360") {
    return <Report360 />;
  }

  if (meta.type === "clearscreen") {
    return (
      <Card p="xl">
        <ClearscreenReport />
      </Card>
    );
  }

  if (meta.type === "competency") {
    return <CompetencyAssessment />;
  }

  if (meta.type === "engagement") {
    return <EngagementReport />;
  }

  if (meta.type === "compare") {
    return <div>Compare Report</div>;
  }

  return <div>ReportDisplay</div>;
}
